import { Grid } from '@mui/material';
import { type FC } from 'react';
import { Outlet } from 'react-router';

const Reports: FC = () => {
  return (
    <Grid
      container
      justifyContent='space-between'
    >
      <Grid
        item
        xs={14}
      >
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default Reports;
